import DatePickerRange from 'components/PeriodSelection/DatePickerRange';
import { format } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';


export function EditSongPerformingArtist(songSplitsDetail: any) {

    const [showtab, setShowTab] = useState(1);
    const [showSubtab, setShowSubTab] = useState(4);

    return (
        <>
            <div className='ws-12'>

                <div className="alert alert-success ng-binding ng-hide" data-ng-show="showPerformingArtistSuccessSaveMsg">Performing Artist  saved successfully </div>

                <div className="alert alert-danger ng-binding ng-hide"> There was a problem submitting your request, one or more fields are missing or  incorrect.  </div>


                <div className="form-format ws-12 m0 ng-hide" data-ng-show="performingArtistDisplay">
                    <div className="ws-6">

                        <div className="form-format m0 mt ng-hide" data-ng-hide="true">
                            <label className="control-label ng-binding" id="songID">SongID</label>
                            <div className="label-entries">
                                <input type="text" name="songID"  data-ng-model="performingArtistDetails.songID" />
                            </div>
                        </div>

                        <div className="form-format m0 mt">
                            <label className="control-label ng-binding" id="performingArtist">Performing Artist
                            </label>
                            <div className="label-entries">
                                <div className="ws-8">
                                    <input type="text" className="form-control text-uppercase ng-pristine ng-untouched ng-valid" placeholder="Performing Artist" ng-model="performingArtistDetails.performingArtistDisplay" name="kontactCode" ng-click="contactOpener('kontactCode', 'performingArtistDisplay')" readOnly /></div>
                                <div className="ws-4">
                                    <button type="button" className="btn-success" ng-click="contactOpener('kontactCode', 'performingArtistDisplay')" title="Select Contact"><i className="icon-user-add"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ws-6">
                        <div className="form-format m0 mt">
                            <label className="control-label ng-binding" id="IPI">IPI Name Number</label>
                            <div className="label-entries ws-8">
                                <input type="text" name="IPI"  placeholder="IPI Name Number" data-ng-model="performingArtistDetails.iPINameNumber" readOnly />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )

}